import { Component } from '@verndale/core';

class ReturnToTop extends Component {
  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

export default ReturnToTop;
